import { Link } from "react-router";
import type { ScheduleEntry } from "@edu/shared";
import { assignHref, homeworkOffered, planOfEntry } from "./entry-homework.ts";

/**
 * «Задать домашку» прямо из карточки занятия. Правила и разбор решений в
 * `entry-homework.ts`, здесь только разметка.
 *
 * ⚠️ Запроса тут нет ни одного, и это заслуга контракта: заготовка приезжает
 * строкой сетки уже разрешённой (`ScheduleEntry.planId`). До 03.09.2026 её
 * приходилось доспрашивать у урока при каждом открытии карточки, потому что в
 * строке лежала только правка занятия.
 */
export function EntryHomework(props: { entry: ScheduleEntry }) {
  const { entry } = props;
  if (!homeworkOffered(entry)) return null;

  const studentUserId = entry.counterpartUserId;
  // Недостижимо (`homeworkOffered` это уже проверил), но управление сюда обязано
  // доходить с непустым идентификатором, иначе адрес собрать не из чего
  if (studentUserId === null) return null;

  return (
    <p className="muted">
      <Link
        className="textlink"
        to={assignHref({
          studentUserId,
          planId: planOfEntry(entry),
          lessonId: entry.lessonId,
        })}
      >
        задать домашку
      </Link>
    </p>
  );
}
